import {
  CreditCard,
  Gift,
  GraduationCap,
  Handshake,
  LayoutDashboard,
  Package,
  Repeat,
  Settings,
  ShoppingCart,
  Users,
  Wallet,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type NavPath =
  | '/'
  | '/vendas'
  | '/produtos'
  | '/area-membros'
  | '/assinaturas'
  | '/afiliados'
  | '/coproducoes'
  | '/financas'
  | '/indicacoes'
  | '/recupera-ai'
  | '/config'

export type NavItem = {
  to: NavPath
  label: string
  icon: LucideIcon
}

export const navItems: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/vendas', label: 'Vendas', icon: CreditCard },
  { to: '/produtos', label: 'Produtos', icon: Package },
  { to: '/area-membros', label: 'Área de membros', icon: GraduationCap },
  { to: '/assinaturas', label: 'Assinaturas', icon: Repeat },
  { to: '/afiliados', label: 'Afiliados', icon: Users },
  { to: '/coproducoes', label: 'Coproduções', icon: Handshake },
  { to: '/financas', label: 'Recebimentos', icon: Wallet },
  { to: '/indicacoes', label: 'Indique e ganhe', icon: Gift },
  { to: '/recupera-ai', label: 'Recupera AI', icon: ShoppingCart },
  { to: '/config', label: 'Config', icon: Settings },
]

export const bottomNavItems: NavItem[] = navItems.filter((item) =>
  ['/', '/vendas', '/produtos', '/financas'].includes(item.to),
)

export const mobileMoreNavItems: NavItem[] = navItems.filter(
  (item) => !bottomNavItems.some((primaryItem) => primaryItem.to === item.to),
)

export function navItemMatchesPath(itemPath: NavPath, pathname: string): boolean {
  if (itemPath === '/') return pathname === '/'
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`)
}
